/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentV1AgentCompatibilityProfilePatch422Response model module.
 * @module model/AgentV1AgentCompatibilityProfilePatch422Response
 * @version 1.0.0
 */
class AgentV1AgentCompatibilityProfilePatch422Response {
    /**
     * Constructs a new <code>AgentV1AgentCompatibilityProfilePatch422Response</code>.
     * @alias module:model/AgentV1AgentCompatibilityProfilePatch422Response
     */
    constructor() { 
        
        AgentV1AgentCompatibilityProfilePatch422Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentV1AgentCompatibilityProfilePatch422Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentV1AgentCompatibilityProfilePatch422Response} obj Optional instance to populate.
     * @return {module:model/AgentV1AgentCompatibilityProfilePatch422Response} The populated <code>AgentV1AgentCompatibilityProfilePatch422Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentV1AgentCompatibilityProfilePatch422Response();

            if (data.hasOwnProperty('errors')) {
                obj['errors'] = ApiClient.convertToType(data['errors'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentV1AgentCompatibilityProfilePatch422Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentV1AgentCompatibilityProfilePatch422Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['errors'])) {
            throw new Error("Expected the field `errors` to be an array in the JSON data but got " + data['errors']);
        }

        return true;
    }


}



/**
 * @member {Array.<String>} errors
 */
AgentV1AgentCompatibilityProfilePatch422Response.prototype['errors'] = undefined;






export default AgentV1AgentCompatibilityProfilePatch422Response;

